var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeIconLi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1392_4488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12158 6.01128C5.63636 4.79041 4.4329 3.33649 3.52855 1.64258C3.34768 1.30519 2.92683 1.17649 2.58596 1.35736C2.24857 1.53823 2.11985 1.95911 2.30072 2.29998C3.2955 4.15389 4.6103 5.74694 6.23813 7.08607C6.53378 7.32955 6.9755 7.2878 7.21898 6.99215C7.46246 6.69302 7.41723 6.25475 7.12158 6.01128Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32953 1.25651C6.40605 2.66172 6.47563 4.06694 6.56259 5.47216C6.58693 5.85477 6.91737 6.14694 7.29998 6.12259C7.68258 6.09824 7.97476 5.76781 7.95041 5.3852C7.86345 3.98346 7.79387 2.58173 7.71735 1.17651C7.69648 0.794949 7.36605 0.501034 6.98344 0.522599C6.60083 0.544164 6.30518 0.872855 6.32953 1.25651Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4933 1.54126C10.6029 2.88387 9.59426 4.12211 8.57861 5.37429C8.33513 5.67342 8.38032 6.1117 8.67945 6.3517C8.97858 6.59518 9.41686 6.54995 9.65686 6.25082C10.7003 4.96734 11.7369 3.69081 12.6551 2.30994C12.8673 1.98994 12.7768 1.55865 12.4568 1.34648C12.1403 1.1343 11.7055 1.22126 11.4933 1.54126Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9426 6.53304C12.5287 6.64086 9.96522 6.64434 7.55131 6.4913C7.1687 6.47043 6.83827 6.75913 6.81392 7.14521C6.78957 7.52782 7.08174 7.85825 7.46435 7.8826C9.92696 8.03565 12.5426 8.03217 15.0052 7.92434C15.3878 7.90695 15.6869 7.58 15.6696 7.19739C15.6522 6.81479 15.3252 6.51564 14.9426 6.53304Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23624 6.97522C7.72494 8.79783 9.26582 10.5857 10.6467 12.4918C10.8728 12.8013 11.3076 12.8709 11.6206 12.6448C11.9302 12.4187 11.9997 11.9839 11.7736 11.6743C10.3754 9.74738 8.81714 7.93869 7.31105 6.09521C7.06758 5.79956 6.62929 5.75435 6.33364 5.99783C6.03451 6.24131 5.99276 6.67957 6.23624 6.97522Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6871 7.5031C7.07666 9.40223 7.18449 11.2179 7.21232 13.1414C7.2158 13.524 7.53232 13.8301 7.91493 13.8266C8.30102 13.8196 8.6071 13.5066 8.60014 13.1205C8.57231 11.1066 8.45755 9.21093 8.05059 7.22136C7.97059 6.84571 7.60537 6.60221 7.22624 6.68221C6.85059 6.75874 6.6071 7.12745 6.6871 7.5031Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7499 7.35061C5.62294 9.60453 5.04207 12.1089 3.83511 14.3141C3.65076 14.648 3.77596 15.0723 4.11335 15.2567C4.45074 15.441 4.87164 15.3158 5.05598 14.9819C6.2699 12.7628 6.85771 10.2445 7.9951 7.97322C8.16553 7.62887 8.0264 7.21148 7.68553 7.03756C7.34118 6.86713 6.92381 7.00627 6.7499 7.35061Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37011 6.83863C5.12664 7.23515 2.88663 7.41602 0.629243 7.68384C0.246634 7.72906 -0.0246702 8.07342 0.0205472 8.45603C0.0657646 8.83864 0.410145 9.10994 0.792753 9.06472C3.07449 8.7969 5.34231 8.60906 7.61362 8.20906C7.98927 8.1395 8.24318 7.77776 8.17709 7.4021C8.10753 7.02297 7.74924 6.76906 7.37011 6.83863Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93127 5.78192C8.46866 5.76105 8.0304 5.72974 7.57822 5.66365C7.19561 5.608 6.8443 5.87235 6.78865 6.25148C6.733 6.63061 6.99733 6.9854 7.37646 7.04105C7.87733 7.11409 8.36082 7.14887 8.86864 7.16974C9.25125 7.18713 9.57819 6.89147 9.59211 6.50538C9.6095 6.12277 9.31388 5.79931 8.93127 5.78192Z",
    fill: "#EE6666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1392_4488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeIconLi);
export default __webpack_public_path__ + "static/media/OrangeIconLi.608552e55ee7bafcd3fcf1983badb5a5.svg";
export { ForwardRef as ReactComponent };